// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_i5-0";
export var fileCarousel = "_i5-2";
export var removeFileButton = "_i5-1";